import Vue from 'vue'

// Truncate
Vue.filter('truncate', function (text, length, clamp) {
  clamp = clamp || '...'
  length = length || 30

  if (text.length <= length) {
    return text
  } else {
    return text.substring(0, length) + clamp
  }
})

// Pluralize
const toArray = function (list, start) {
  start = start || 0
  var i = list.length - start
  var ret = new Array(i)
  while (i--) {
    ret[i] = list[i + start]
  }
  return ret
}
Vue.filter('pluralize', function (value) {
  var args = toArray(arguments, 1)
  return args.length > 1
    ? (args[value % 10 - 1] || args[args.length - 1])
    : (args[0] + (value === 1 ? '' : 's'))
})

// Uppercase
Vue.filter('uppercase', function (value) {
  return (value || value === 0)
    ? value.toString().toUpperCase()
    : ''
})

// Lowercase
Vue.filter('lowercase', function (value) {
  return (value || value === 0)
    ? value.toString().toLowerCase()
    : ''
})

// Capitalize
Vue.filter('capitalize', function (value) {
  if (!value && value !== 0) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

// Currency
Vue.filter('currency', function (value, currency, decimals) {
  var digitsRE = /(\d{3})(?=\d)/g
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : '$'
  decimals = decimals != null ? decimals : 2
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
})

Vue.filter('comma', function (value) {
  return value
    ? `${value}, `
    : ''
})



// WEBPACK FOOTER //
// ./src/utils/filters.js